export interface GeoAttrs {
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

enum AddressPartsType {
  State = 'administrative_area_level_1',
  Locality = 'locality',
  PostalCode = 'postal_code',
  Country = 'country',
}

const getAddressParts = (addressComponents: google.maps.places.AddressComponent[]) => {
  return addressComponents.reduce(
    (acc, component) => {
      const { types } = component;
      const longName = component.longText ?? '';
      const shortName = component.shortText ?? '';

      if (types.includes(AddressPartsType.State)) {
        acc.state = shortName;
      }

      if (types.includes(AddressPartsType.Locality)) {
        acc.city = longName;
      }

      if (types.includes(AddressPartsType.PostalCode)) {
        acc.zip = shortName;
      }

      if (types.includes(AddressPartsType.Country)) {
        acc.country = longName;
      }

      return acc;
    },
    { state: '', city: '', zip: '', country: '', street: '' } as GeoAttrs,
  );
};

export default getAddressParts;
